import { useCallback, useEffect, useLayoutEffect, useRef } from 'react';
/**
 * React hook that enables to call functions from keyboard shortcuts
 *
 * @param keys - Array of keys that trigger the shortcut
 * @param callback - Function that gets called when the shortcut happens
 * @param node - HTML node object
 *
 */
export function useKeyPressShortcut(
    keys: Array<any>,
    callback: Function,
    node = null,
) {
    // implement the callback ref pattern
    const callbackRef = useRef(callback);
    useLayoutEffect(() => {
        callbackRef.current = callback;
    });

    // handle what happens on key press
    const handleKeyPress = useCallback(
        (event: KeyboardEvent) => {
            // check if one of the key is part of the ones we want
            if (keys.some((key) => event.key === key)) {
                callbackRef.current(event);
            }
        },
        [keys],
    );

    useEffect(() => {
        // target is either the provided node or the document
        const targetNode = node ?? document;
        // attach the event listener
        targetNode && targetNode.addEventListener('keydown', handleKeyPress);

        // remove the event listener
        return () =>
            targetNode &&
            targetNode.removeEventListener('keydown', handleKeyPress);
    }, [handleKeyPress, node]);
}

/*Example: https://devtrium.com/posts/how-keyboard-shortcut*/
